module.exports = __webpack_public_path__ + "img/collection-memoireRingsRosegold@2x.686b92e.jpg";